import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import PoolAccessGuard from '../auth/PoolAccessGuard';
import PoolManagement from '../../pages/PoolManagement';
import PoolMonitoring from '../../pages/PoolMonitoring';
import { CCTV_POPUP_RESERVED_SEGMENTS } from '../monitoring/cctvPopupRoutes';
import { readPoolSiteView } from '../../utils/poolSitePaths';

/**
 * 현장·시설 최초 접속: http://<도메인>/POOL001
 * 주소창은 /POOL001 유지, location.state.poolSiteView 로 관리/모니터링 화면 분기
 */
const PoolShortEntryRoute: React.FC = () => {
  const { poolCode } = useParams<{ poolCode: string }>();
  const location = useLocation();

  if (!poolCode) {
    return <Navigate to="/central-control" replace />;
  }

  const decoded = decodeURIComponent(poolCode);
  if (CCTV_POPUP_RESERVED_SEGMENTS.has(decoded.toLowerCase())) {
    return <Navigate to="/central-control" replace />;
  }

  const view = readPoolSiteView(location.state);

  return (
    <PoolAccessGuard>
      {view === 'monitoring' ? <PoolMonitoring /> : <PoolManagement />}
    </PoolAccessGuard>
  );
};

export default PoolShortEntryRoute;
